import React, { useRef } from "react";
import useTitle from "../../Hooks/useTitle";
import email from "../../AnimatedIcons/email.json";
import Lottie from "lottie-react";
import emailjs from "@emailjs/browser";

const Contact = () => {
  useTitle("Contact");
  const form = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_om27p2b",
        "template_ti1x9d4",
        form.current,
        "1-labrLP1--5silTi"
      )
      .then(
        (result) => {
          console.log(result.text);
          form.reset();
        },
        (error) => {
          console.log(error.text);
        }
      );
  };
  return (
    <div className="bg-primary h-screen">
      <div className="container mx-auto">
        <div className="flex lg:justify-start md:justify-start sm:justify-center justify-center gap-6">
          <h2 className="text-accent lg:text-start md:text-start sm:text-center text-center lg:text-7xl md:text-4xl sm:text-xl text-xl pb-10 pt-12 font-semibold hover:scale-110 hover:-rotate-2 transition-all ease-in-out delay-75 duration-500 hover:text-green-400">
            LET'S GET IN TOUCH!
          </h2>
          <Lottie
            animationData={email}
            className="lg:w-24 md:w-24 sm:w-14 w-14 hover:scale-110 hover:rotate-1 transition-all ease-in-out delay-75 duration-500"
            href=""
          ></Lottie>
        </div>
        <p className="lg:text-start md:text-start sm:text-center text-center lg:text-3xl md:text-3xl sm:text-sm text-sm font-light text-success pb-6 hover:scale-110 hover:rotate-1 transition-all ease-in-out delay-75 duration-500 hover:text-yellow-500">
          If you liked my work and want to share ideas for any collaborations,
          or just want to talk about technology, design or creativity, I am just
          an email away! It would be my pleasure to chat with you.
        </p>
        <form ref={form} onSubmit={sendEmail}>
          <div className="mt-10 lg:mx-0 md:mx-0 sm:mx-auto mx-auto">
            <div>
              <input
                required
                name="email"
                type="text"
                placeholder="Email"
                className="input input-bordered input- bg-primary border-2 transition-all ease-in-out duration-700 text-success focus:bg-secondary w-full mb-4 "
              />
            </div>
            <div>
              <input
                required
                type="text"
                name="subject"
                placeholder="Subject"
                className="input input-bordered input- bg-primary border-2 transition-all ease-in-out duration-700 text-success focus:bg-secondary w-full mb-4 "
              />
            </div>
            <div>
              <textarea
                name="message"
                className="textarea textarea-accent input input-bordered input- bg-primary border-2 transition-all ease-in-out duration-700 text-success focus:bg-secondary w-full h-40 mb-4 "
                placeholder="Message"
                required
              ></textarea>
            </div>
            <button
              className="text-sm border-b-2 border-b-green-400 text-green-400 hover:border-green-300 hover:text-green-300 transition-all ease-in-out duration-700 hover:cursor-pointer mt-6 lg:mx-0 md:mx-0 sm:mx-auto mx-auto"
              type="submit"
              value="send"
            >
              SUBMIT
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Contact;
